export default {
  title: 'Filtrer par dates de publication (du... au...)'
}
